import { NavLink } from "react-router"

import { groupSitemapByArea } from "./helpUtils"

import "./HelpSidebar.scss"

export default function HelpSidebar({ sitemap, availableAreas, isOpen, onNavigate }) {
  const groups = groupSitemapByArea(sitemap, availableAreas)

  return (
    <>
      {isOpen && <div className="HelpSidebar-backdrop" onClick={onNavigate} />}
      <aside className={`HelpSidebar${isOpen ? " open" : ""}`}>
        {groups.length === 0 && (
          <div className="HelpSidebar-empty">No help areas available.</div>
        )}
        {groups.map(({ area, title, pages }) => {
          if (pages.length === 0) {
            return (
              <section key={area} className="HelpSidebar-group">
                <h3 className="HelpSidebar-groupTitle">{title}</h3>
                <div className="HelpSidebar-empty">No pages yet.</div>
              </section>
            )
          }
          if (pages.length === 1) {
            return (
              <NavLink
                key={area}
                to={`/help/${area}/${pages[0].slug}`}
                onClick={onNavigate}
                className={({ isActive }) =>
                  "HelpSidebar-areaLink" + (isActive ? " active" : "")
                }
              >
                {title}
              </NavLink>
            )
          }
          return (
            <section key={area} className="HelpSidebar-group">
              <h3 className="HelpSidebar-groupTitle">{title}</h3>
              <ul className="HelpSidebar-pages">
                {pages.map((page) => (
                  <li key={page.slug}>
                    <NavLink
                      to={`/help/${area}/${page.slug}`}
                      onClick={onNavigate}
                      className={({ isActive }) =>
                        "HelpSidebar-pageLink" + (isActive ? " active" : "")
                      }
                    >
                      {page.title}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </section>
          )
        })}
      </aside>
    </>
  )
}
